import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-site-root',
  templateUrl: './site-root.component.html',  
  styleUrls: ['./site-root.component.scss']
})
export class SiteRootComponent implements OnInit {
  @ViewChild('videoElement', { static: true }) _videoElement: any;
  @ViewChild('PauseButton', { static: true }) _PauseButtonElement: any;

  _PlayingStatus = '';
  _Video: any;
  _PauseButton: any;
  constructor() { }

  ngOnInit() {
    /*
    this._PlayingStatus = 'Playing...';
    this._Video = this._videoElement.nativeElement;
    this._Video.addEventListener('ended', this.videoEnded);
    this._Video.addEventListener('touchstart', this.videoPlay);
    this._PauseButton = this._PauseButtonElement.nativeElement;
    this._Video.play();
    */
  }

  PauseToggle(e) {
    /*    
    this._Video.classList.toggle('stopfade');
    if (this._Video.paused) {

      this. _Video.play();
        this._PauseButton.innerHTML = 'Pause';
        this._PlayingStatus = '(Playing)';
    } else {

      this._Video.pause(); this._PauseButton.innerHTML = 'Play';
      this._PlayingStatus = '(Paused)';
    }
    */
}

videoPlay(e) {
    /*
    e.preventDefault();
    this._Video.play();
    */
}
videoFade() {
    /*
    this._Video.classList.add('stopfade');
    */
}
videoEnded() {
    /*
    this._Video.pause();
    this.videoFade();
    */
}


}